import { useQuery } from '@apollo/client';
import { GET_DETAIL_ORGANIZATION_USER_PRO } from '@gql/organization-users';
import { GET_PRO } from '@gql/pros';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import OrganizationUserForm from './forms/OrganizationUserForm';

const OrganizationUserEdit = () => {
    const { id: companyId, userId } = useParams<{ id: string; userId: string }>();
    const navigate = useNavigate();

    const { data: proData, loading: loadingPro } = useQuery(GET_PRO, {
        variables: { proId: companyId },
        skip: !companyId,
    });

    const { data: userData, loading: loadingUser } = useQuery(GET_DETAIL_ORGANIZATION_USER_PRO, {
        variables: { id: userId, proId: companyId },
        skip: !userId || !companyId,
    });

    const pro = proData?.getPro;

    if (loadingPro || loadingUser) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
                <CircularProgress />
            </Box>
        );
    }

    if (!pro) {
        return <Box>Company not found</Box>;
    }

    if (!userData?.getOrganizationUser) {
        return <Box>User not found</Box>;
    }

    return (
        <Box sx={{ width: '100%' }}>
            <OrganizationUserForm
                proId={pro._id}
                selectedData={userData.getOrganizationUser}
                setIsActiveForm={(value) => {
                    if (value === '') {
                        navigate(`/companies/${companyId}/users/${userId}`);
                    }
                }}
            />
        </Box>
    );
};

export default OrganizationUserEdit;
